import axios from "axios";
import { auth } from "../firebase";
import { jwtDecode } from "jwt-decode";

// cache the last‐fetched token
let currentIdToken = null;

const isTokenValid = (token) => {
  try {
    // Decode the token without verifying the signature.
    const decoded = jwtDecode(token);
    // Check if the token has an expiration (exp is in seconds).
    if (!decoded.exp) return false;

    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return false;
  }
};

/**
 * Returns a fresh Firebase ID token, refreshing it if it’s
 * expired or missing. Resolves to null if no user is signed in.
 */
async function getFreshIdToken() {
  if (!auth.currentUser) {
    return null;
  }

  // if we’ve never fetched one yet, or it’s expired, force a refresh
  if (!currentIdToken || !isTokenValid(currentIdToken)) {
    currentIdToken = await auth.currentUser.getIdToken(/* forceRefresh */ true);
  }

  return currentIdToken;
}

// create a dedicated Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // http://localhost:8787
});

// automatically inject Authorization header
apiClient.interceptors.request.use(
  async (config) => {
    const freshToken = await getFreshIdToken();
    if (freshToken) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${freshToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
